export const ROW_SUMMARY_ROW_ID = '__ROW_SUMMARY_ROW_ID';
export const WEIGHTED_AVERAGE_AGGREATED_FUNCTION = 'WEIGHTED_AVERAGE';
export const summarySupportedExpressions = [
    'MIN',
    'MAX',
    'SUM',
    'AVG',
    'COUNT',
    'MEDIAN',
    'MODE',
    'DISTINCT',
    'ONLY',
    'STD_DEVIATION',
    WEIGHTED_AVERAGE_AGGREATED_FUNCTION,
];
